export enum DeleteReasons {
    HaveAnotherAccount = 'haveAnotherAccount',
    TooExpensive = 'tooExpensive',
    NotEarningEnough = 'notEarningEnough',
    NotEnoughPeople = 'notEnoughPeople',
    WorriedAboutPrivacy = 'worriedAboutPrivacy',
    NoLongerInterested = 'noLongerInterested',
    ReceivedInsultsOrThreats = 'receivedInsultsOrThreats',
    Other = 'other',
}
